<template>
	<div v-if="false"></div>
</template>

<script>
export default {
	name: 'PageUnloadAlert',
	props: {
		/**
		 * current browsers won't support a custom message
		 */
		Message: {
			type: String
		},
		enabled: {
			type: Boolean,
			default: true
		}
	},
	mounted() {
		window.addEventListener('beforeunload', this.beforeUnloadListener, {
			capture: true
		});
	},
	destroyed() {
		window.removeEventListener('beforeunload', this.beforeUnloadListener, {
			capture: true
		});
	},
	methods: {
		beforeUnloadListener(e) {
			if (!this.enabled) return;

			e.preventDefault();

			this.$emit('beforeunload');

			//current browsers won't support a custom message
			return (e.returnValue = this.message);
		}
	}
};
</script>

<style lang="scss" scoped></style>
